import {Component, OnInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {LotteryMath} from "./lotteryMath";
import {SixMarkBaseComponent} from "../sixmark/sixMarkBase";

@Component({
  selector: 'lottery-math-sm',
  templateUrl: 'selectMathSM.html',
  styleUrls: [ '/sm.scss' ]
})
export class LotteryMathSMComponent implements LotteryMath, OnInit {
  @ViewChild('smGame') sixMarkBase: SixMarkBaseComponent;
  _selectAreaOption: any;
  _enableBalance: number = 0;
  selectLayout: any = [];
  btnsOption: any = [];

  // Indicate game type: SM01 to SM05
  gameType: string = 'SM01';
  // The title of the game
  title: string;
  currentGameTotal: number = 0;
  @Input()
  set enableBalance(enableBalance: number) {
    if (enableBalance) {
      this._enableBalance = enableBalance;
    }
  }
  get enableBalance() {
    return this._enableBalance;
  }

  @Input() showCoverBg: boolean = false;

  @Input()
  set selectAreaOption(selectAreaOption: any) {
    if (selectAreaOption) {
      this.title = selectAreaOption.title;
      this.gameType = selectAreaOption.mname;
      this.selectLayout = selectAreaOption.layout;

      this._selectAreaOption = selectAreaOption;
    }
  }
  get selectAreaOption() {
    return this._selectAreaOption;
  }

  @Output() onTotal: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBetInfo: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOptionSelected: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
  }

  changeTotal(selectInfo: any) {
    // TODO: Required to implement this function
  }

  betOption(params) {
    this.onOptionSelected.emit(params);
  }

  /**
   * Cancel current bets
   */
  cancelCurrentBets() {
    this.sixMarkBase.cancelCurrentBets();
  }

  /**
   * Calculate the total amount for the current bet
   * @param selectedCoinAmount
   */
  calculateCurrentBetTotal(selectedCoinAmount) {
    this.sixMarkBase.calculateCurrentBetTotal(selectedCoinAmount);
  }

  /**
   * Update current game total
   * @param total
   */
  setTotal(total) {
    this.currentGameTotal = total;
    this.onTotal.emit(total);
  }
  /**
   * Update betInfo
   * @param betInfo
   */
  setBetInfo(betInfo) {
    this.onBetInfo.emit(betInfo);
  }

  /**
   * Remove the last item of betting history
   */
  popBackBetHistory() {
    this.sixMarkBase.popBackBetHistory();
  }

  /**
   * Remove all items from betting history
   */
  clearBetHistory() {
    this.sixMarkBase.clearBetHistory();
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/sm.ts